import classNames from "classnames";
import AscCircularProgressBar from "../../AscCircularProgressBar/AscCircularProgressBar";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscSkillsActivityStatsCard.module.scss";
import AscButton from "../../AscButton/AscButton";

export interface AscSkillsActivityStatsCardProps {
  title?: string;
  subtitle?: string;
  completed: number;
  total: number;
  averageGradePercentage: number;
  completedModulesPercentage?: number;
  className?: string;
  bodyClassName?: string;
  footerClassName?: string;
  color?: string;
  loading?: boolean;
  isPillarGrade?: boolean;
  isFromTracksStage?: boolean;
  isFromBullpenApplication?: boolean;
  onCompleteClick?: () => void;
  footer?: React.ReactNode;
}

export default function AscSkillsActivityStatsCard({
  title,
  subtitle,
  completed,
  total,
  averageGradePercentage,
  completedModulesPercentage,
  className,
  bodyClassName,
  footerClassName,
  color,
  loading = false,
  isFromTracksStage = false,
  isFromBullpenApplication = false,
  isPillarGrade = false,
  onCompleteClick,
  footer,
}: AscSkillsActivityStatsCardProps) {
  const completedPercentage = completedModulesPercentage
    ? completedModulesPercentage
    : (completed / (total || 1)) * 100;
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      bodyClassName={classNames(styles.cardBody, bodyClassName)}
      contentClassName={styles.cardContent}
      title={
        title
          ? title
          : isFromTracksStage || isFromBullpenApplication
          ? "Your score"
          : "Your Activity"
      }
      coverImageUrl={null}
      loading={loading}
      footer={footer}
      footerClassName={classNames(footerClassName)}
    >
      <AscCircularProgressBar
        className={styles.progressBar}
        percentage={
          isFromBullpenApplication
            ? averageGradePercentage
            : completedPercentage
        }
        color={color}
      />
      <div className={styles.textContent}>
        <div className={styles.complete}>
          {subtitle
            ? subtitle
            : isFromTracksStage
            ? "Track completion"
            : isFromBullpenApplication
            ? "My Application"
            : `${completed}/${total} Complete`}
        </div>
        <div className={styles.averageContainer}>
          {isFromBullpenApplication ? (
            <AscButton size="small" onClick={onCompleteClick}>
              Complete
            </AscButton>
          ) : (
            <>
              <div className={styles.average}>
                {averageGradePercentage?.toFixed(0)}%
              </div>
              <div className={styles.averageLabel}>
                <span className={styles.averageText}>
                  {isPillarGrade
                    ? "pillar"
                    : isFromTracksStage
                    ? "topic"
                    : "average"}
                </span>
                <span className={styles.gradeText}>
                  {isFromTracksStage ? "grade" : "score"}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </AscGenericCard>
  );
}
